import Vue from 'vue';
import Toast from './toast.vue';
/**
 * 显示 Toast 提示
 * @param {string} [message=''] - 提示文本
 * @param {number} [delay=2000] - 自动关闭延迟（毫秒）
 * @param {string|HTMLElement} [target='body'] - 插入的目标节点（选择器字符串或DOM元素）
 */
export default function showToast() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
  var target = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.app';
  // 移除之前可能存在的toast元素（避免重复）
  var prevToast = document.getElementById('my-toast');
  if (prevToast) {
    prevToast.remove();
  }
  // 创建组件实例
  var toastInstance = new Vue({
    render: function render(h) {
      return h(Toast, {
        props: {
          message: message
        }
      });
    }
  }).$mount();
  // 创建容器
  var container = document.createElement('div');
  container.id = 'my-toast';
  container.appendChild(toastInstance.$el);
  // 获取目标节点（支持选择器字符串或DOM元素）
  var targetNode;
  if (typeof target === 'string') {
    // 如果是字符串，视为选择器
    targetNode = document.querySelector(target);
  } else if (target instanceof HTMLElement) {
    // 如果是DOM元素，直接使用
    targetNode = target;
  }
  // 兜底：如果目标节点不存在，默认插入到body
  if (!targetNode) {
    targetNode = document.body;
  }
  // 将容器插入到目标节点（作为目标节点的子元素）
  targetNode.appendChild(container);
  // 定时移除toast
  setTimeout(function () {
    if (container.parentNode) {
      container.parentNode.removeChild(container);
    }
    toastInstance.$destroy();
  }, delay);
}